import { Button, Grid, MenuItem, FormControl, InputLabel, Select } from "@material-ui/core"
import { BPagoStyle } from "./BpagoStyles"
import { useDispatch } from "react-redux"
import { obtenerPagosAction } from "../../../ducks/pagosDuck"
import { useEffect, useState } from "react"
import PickerMod from "../../../global/PickersMod"
import { FormatoFecha } from "../../../utils/FormatFecha"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { esFechaValida, formatEndMounth, formatStartMounth, endMounth, startMounth } from "../../../utils/FormatFecha"
import { addFechasIngresosFinalAction, addFechasIngresosIncioAction } from "../../../ducks/reportesDuck"
import ButtonReporteIngresos from "../../Reportes/ButtonReporteIngresos"
const BPago = () => {
  const dispatch = useDispatch()
  const classes = BPagoStyle()
  const [selectDayInicio, setSelectedDateInicio] = useState(new Date())
  const [selectDayFin, setSelectedDateFin] = useState(new Date())
  const [tipoBusqueda, setTipoBusqueda] = useState("0")
  const handleChange = (event) => {
    setTipoBusqueda(event.target.value)
  }
  const onBusacar = () => {
    if (!esFechaValida({ date: selectDayInicio }) && !esFechaValida({ date: selectDayFin }))
      return null

    dispatch(onLoadAnction({ message: "" }))
    let fechaIncio = FormatoFecha({ date: selectDayInicio, formato: "dd-MM-yyyy" })
    let fechaFinal = FormatoFecha({ date: selectDayFin, formato: "dd-MM-yyyy" })
    let fechaInicioReporte = selectDayInicio
    let fechaFinalReporte = selectDayFin
    if (tipoBusqueda === "1") {
      fechaIncio = formatStartMounth({ date: selectDayInicio, formato: "dd-MM-yyyy" })
      fechaFinal = formatEndMounth({ date: selectDayInicio, formato: "dd-MM-yyyy" })
      fechaInicioReporte = startMounth({date: selectDayInicio})
      fechaFinalReporte = endMounth({ date: selectDayFin })
    }
    dispatch(
      obtenerPagosAction(fechaIncio, fechaFinal)
    ).then(Response => {
      dispatch(offLoadAction())
      dispatch(addFechasIngresosFinalAction({ FechaFin: fechaFinalReporte }))
      dispatch(addFechasIngresosIncioAction({ FechaIni: fechaInicioReporte }))
    })
  }
  useEffect(() => {
    dispatch(onLoadAnction({ message: "" }))
    dispatch(
      obtenerPagosAction(
        FormatoFecha({ date: selectDayInicio, formato: "dd-MM-yyyy" }),
        FormatoFecha({ date: selectDayFin, formato: "dd-MM-yyyy" })
      )
    ).then(Response => {
      dispatch(offLoadAction())
      dispatch(addFechasIngresosFinalAction({ FechaFin: selectDayFin }))
      dispatch(addFechasIngresosIncioAction({ FechaIni: selectDayInicio }))
    })
  }, [])
  return (
    <>
      <Grid container spacing={1} alignItems="center" justifyContent="space-between">
        <Grid item xs={4}>
          <div>
            <FormControl variant="outlined" style={{ width: "100%", margin: "0 2%" }}>
              <InputLabel id="lEstatus">Buscar por</InputLabel>
              <Select
                labelId="lTipoBusquedaPago"
                id="STipoBusquedaPago"
                name="tipoBusquedaPago"
                value={tipoBusqueda}
                onChange={handleChange}
                label="Buscar por"
              >
                <MenuItem value="0">
                  {"Intervalo de fechas"}
                </MenuItem>
                <MenuItem value="1">
                  {"Mes"}
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div style={{display: "flex", justifyContent: "flex-end"}}>
            <ButtonReporteIngresos />
          </div>
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing} spacing={1} alignItems="center" >
        <Grid item xs={3}>
          <PickerMod
            id="fechaIncioPagosBusqueda"
            label="Desde"
            selectedDate={selectDayInicio}
            setSelectedDate={setSelectedDateInicio}
            disablePast={false}
            disableFuture={true}
            formatFecha={tipoBusqueda === "0" ? "dd/MM/yyyy" : "MMMM/yyyy"}
            views={tipoBusqueda === "0" ? ["year", "month", "date"] : ["year","month"]}
          />
        </Grid>
        {
          (tipoBusqueda === "0") &&
          <Grid item xs={3}>
            <PickerMod
              id="fechaFinPagosBusqueda"
              label="Hasta"
              selectedDate={selectDayFin}
              setSelectedDate={setSelectedDateFin}
              disablePast={false}
              disableFuture={true}
            />
          </Grid>
        }
        <Grid item xs={3}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.modalBoton}
            onClick={onBusacar}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
export default BPago
